import React, {useState} from 'react';
import {Button, message} from 'antd';
import {uploadService} from '../../services/upload';
import {DownloadOutlined} from '@ant-design/icons';

function getObsKey(file: any) {
  return file.obskey || file?.original_file_url;
}

function triggerDownload(url: string, file: any) {
  const a = document.createElement('a');

  a.href = url;
  a.download = file.name;
  a.rel = 'noopener noreferrer';

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export function DownloadButton({file}: { file: any }) {
  const [loading, setLoading] = useState(false);

  async function handleDownload() {
    const obskey = getObsKey(file);

    if (!obskey) {
      void message.warning('暂无下载地址');
      return;
    }

    setLoading(true);

    try {
      const res = await uploadService.getTempDownloadUrl({obskey});

      const url = typeof res === 'string' ? res : res?.data;

      if (!url) {
        void message.warning('获取下载地址失败');
        return;
      }

      triggerDownload(url, file);
    } catch (err) {
      void message.warning('下载失败');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Button
      type="text"
      size="small"
      icon={<DownloadOutlined/>}
      className="drive-file-list__icon-btn"
      loading={loading}
      onClick={handleDownload}
    />
  );
}